export default __webpack_public_path__ + "static/media/cross-icon.eb494757.svg";